import { OpenEditTitleWrapper, OpenEditWrapper } from './style';
import React, { useEffect, useState } from 'react';
import { TextArea, Title } from '@icarros/ids-react';

import { Loading } from '../../../components/Loading';
import { SaveFormContent } from './SaveFormContent';
import { useAd } from '../../../store/hooks/useAd';
import { useAdContext } from '../../../store/contexts/ad';

export function DescriptionForm(): JSX.Element {
  const { setCurrentContent, loading, initialLoading } = useAd();
  const { currentAd, setValueIsDifferentFromCurrent, setCurrentWarningMessage } = useAdContext();
  const { texto } = currentAd || {};
  const [description, setDescription] = useState<string>();
  const hasDescriptionError = !description || description.length === 0;
  const REQUIRED_DESCRIPTION =
    'Você precisa escrever uma descrição para o seu anúncio. Ao continuar, sua alteração não será salva.';

  useEffect(() => {
    setDescription(texto);
  }, [texto]);

  useEffect(() => {
    setValueIsDifferentFromCurrent(texto !== description);
  }, [texto, description, setValueIsDifferentFromCurrent]);

  useEffect(() => {
    if (hasDescriptionError) {
      setCurrentWarningMessage({
        title: 'a descrição está em branco',
        body: REQUIRED_DESCRIPTION
      });
    } else {
      setCurrentWarningMessage(undefined);
    }
  }, [setCurrentWarningMessage, hasDescriptionError]);

  return (
    <OpenEditWrapper>
      <OpenEditTitleWrapper>
        <Title size="overline">editar descrição</Title>
        <Title variant="default" contrast="light">
          escreva uma descrição para o seu anúncio
        </Title>
      </OpenEditTitleWrapper>
      {texto !== undefined && (
        <TextArea
          label="descrição do anúncio"
          onChange={event => setDescription(event.target.value)}
          value={description}
          initialValue={texto}
          limitCounter={!hasDescriptionError}
          isError={hasDescriptionError}
          helperText={`${hasDescriptionError ? 'Você precisa escrever uma descrição' : ''}`}
          maxChar={500}
        />
      )}
      {(initialLoading || loading) && <Loading backgroundOnly={loading} />}

      {!(initialLoading && texto === description) && (
        <SaveFormContent
          loading={loading}
          isBody
          isDisabled={texto === description || hasDescriptionError}
          handleClick={() =>
            setCurrentContent({
              texto: description
            })
          }
        />
      )}
    </OpenEditWrapper>
  );
}
